module.exports = __webpack_public_path__ + "img/1375287456.67d6680f.jpg";